var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.btns),function(btn,index){return _c('contact-btn',{key:index,staticClass:"pa-0 ma-0",attrs:{"data-aos":!_vm.disableAnimation ? 'zoom-in' : '',"data-aos-duration":"800","data-aos-delay":250 * index,"mr":btn.mr,"icon":btn.icon,"link":btn.link}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }